const fetchItemsReducer = (currItems = [], action) => {
    if (action.type === "FETCH_ITEMS") {
      return action.payload;
    }
    return currItems;
  };
  
export default fetchItemsReducer;
